































































































































import _ from 'lodash'
import { Component, Vue, Watch } from 'vue-property-decorator'
import moment from 'moment'
import { getModule } from 'vuex-module-decorators'
import RegrasDeCalculoStore from '@/components/RemuneracaoMedica/RegrasDeCalculo/Store/RegrasDeCalculoStore'
import EventBus from '@/plugins/EventBus'
import { DataTablePagination } from '@/types/_'

@Component
export default class FinanceiroTabelaRegrasAgendaGarantiaMinima extends Vue {
  searchProfissional: any = ''
  loadingProfissionalFilter: boolean = false
  shouldProcessPaginationUpdate: boolean = true
  profissionaisDebounced = _.debounce(param => this.getRegrasDeCalculoStore.getProfissionais({nome: param}), 500)

  get getRegrasDeCalculoStore() { return getModule(RegrasDeCalculoStore, this.$store) }

  get regrasAgendaGarantiaMinima() { return this.getRegrasDeCalculoStore.regraAgendaGarantiaMinima }

  loadRegrasDeCalculo: boolean = false
  get loadingRegrasDeCalculo() { return this.loadRegrasDeCalculo }
  set loadingRegrasDeCalculo(value: boolean) { this.loadRegrasDeCalculo = value }

  get paginacaoRegraAgendaGarantiaMinima() { return this.getRegrasDeCalculoStore.paginacaoRegraAgendaGarantiaMinima }

  get nomeRegra() {
    return this.getRegrasDeCalculoStore.nomeRegra
  }

  set nomeRegra(value: string) {
    this.getRegrasDeCalculoStore.setNomeRegra(value)
  }

  get profissionaisExecutantes() {
    return this.getRegrasDeCalculoStore.profissionaisExecutantes
  }

  get selectedProfissionalExecutante() {
    return this.getRegrasDeCalculoStore.profissionalIdAgendaGarantiaMinima
  }

  set selectedProfissionalExecutante(value: any) {
    this.getRegrasDeCalculoStore.setProfissionalIdAgendaGarantiaMinima(value as any)
  }

  get fontesPagadoras() {
    return this.getRegrasDeCalculoStore.fontesPagadoras
  }

  get fontePagadora(){
    return this.getRegrasDeCalculoStore.fontePagadoraField
  }

  set fontePagadora(value: any){
    this.getRegrasDeCalculoStore.setFontePagadoraField(value)
  }

  regrasAgendaGarantiaMinimaHeader = [
    { text: 'Nome', value: 'nome', sortable: false },
    { text: 'Profissional', value: 'profissionalNome', sortable: false },
    { text: 'Estabelecimento', value: 'estabelecimentoNome', sortable: false },
    { text: 'Criado em', value: 'createdOn', sortable: false },
    { text: 'Status', value: 'ativo', sortable: false },
  ]

  loadingEditarRegrasAgendaGarantiaMinima = ''
  showModalDelete = false

  deletarAgendaGarantiaMinima(item: any) {
    this.getRegrasDeCalculoStore.setIdForDeleteGarantiaMinima(item.id)
    this.showModalDelete = true
  }

  fecharModalDelete() {
    this.showModalDelete = false
  }

  async confirmarDelete() {
    const response = await this.getRegrasDeCalculoStore.deleteRegra()

    if (response && response.success !== false) {
      EventBus.$emit('setSnackbar', {
        show: true,
        text: 'Regra excluída com sucesso',
        icon: 'done',
        color: '#2E7D32'
      })
      this.getRegrasDeCalculoStore.getRegraAgendaGarantiaMinima(this.paginacaoRegraAgendaGarantiaMinima)
      this.fecharModalDelete()
    } else {
      EventBus.$emit('setSnackbar', {
        show: true,
        text: 'Erro ao excluir regra',
        icon: 'warning',
        color: '#D32F2F'
      })
    }
  }

  displayDateAndHours(value: any) {
    if (!value) return ' - '
    return moment(value).format('DD/MM/YYYY HH:mm')
  }

  async editarRegrasAgendaGarantiaMinima(item: any) {
    this.loadingEditarRegrasAgendaGarantiaMinima = item.id
    this.getRegrasDeCalculoStore.setNovaRegra(item)
    await this.getRegrasDeCalculoStore.getDescartesProcedimentosByRegraAgendaGarantiaMinima({
      regraId: item.id,
      pagination: this.paginacaoRegraAgendaGarantiaMinima
    })
    this.getRegrasDeCalculoStore.setModeModalAgendaGarantiaMinima('EDIT')
    this.getRegrasDeCalculoStore.setModal({ name: 'regraAgendaGarantiaMinima', value: true })
    this.loadingEditarRegrasAgendaGarantiaMinima = ''
  }

  regrasDeCalculoDebounced = _.debounce(param => this.getRegrasDeCalculoStore.getRegraAgendaGarantiaMinima(param), 700)

  async updatePaginationRegrasDeCalculo(pagination: DataTablePagination) {
    this.loadingRegrasDeCalculo = true
    this.regrasDeCalculoDebounced(pagination)
    this.loadingRegrasDeCalculo = false
  }

  filterResults(){
    this.loadingRegrasDeCalculo = true
    this.regrasDeCalculoDebounced({ ...this.paginacaoRegraAgendaGarantiaMinima, page: 1 })
    this.loadingRegrasDeCalculo = false
  }

  beforeDestroy() {
    this.getRegrasDeCalculoStore.clearRegrasDeCalculo()
    this.getRegrasDeCalculoStore.clearRegraDeCalculo()
    this.getRegrasDeCalculoStore.clearTabelasPreco()
    this.getRegrasDeCalculoStore.clearRegraDeCalculoContratos()
    this.getRegrasDeCalculoStore.clearRegraDeCalculoOperadoras()
    this.getRegrasDeCalculoStore.clearRegraDeCalculoProcedimentosDescartar()
  }

  onProfissionalExecutanteChanged() {
    this.filterResults()
  }

  @Watch('searchProfissional')
  async onSearchProfissionalChanged(val: string) {
    if (!val || val.length < 3){
      this.getRegrasDeCalculoStore.setProfissionaisExecutantes([])
      return
    }
      
    this.loadingProfissionalFilter = true
    if(this.profissionaisDebounced) await this.profissionaisDebounced(val)
    this.loadingProfissionalFilter = false
  }
}
